<script lang="ts" setup>
import { createSize } from "@p-v/utils/factory"
import { ref, watch, inject } from "vue"

const props = withDefaults(
  defineProps<{
    offset: { width: number; height: number }
    anchor: "BMAP_ANCHOR_TOP_LEFT" | "BMAP_ANCHOR_TOP_RIGHT" | "BMAP_ANCHOR_BOTTOM_LEFT" | "BMAP_ANCHOR_BOTTOM_RIGHT"
  }>(),
  {
    offset: () => ({ width: 10, height: 10 }),
    anchor: () => "BMAP_ANCHOR_BOTTOM_RIGHT",
  },
)

const bmap = inject("bmap") as any
const ctrl = ref<any>(undefined)
watch(
  () => bmap.value,
  () => {
    if (!bmap.value) return
    const size = createSize(window.BMapGL, props.offset)
    const anchor = window.BMapGL.ControlAnchor[props.anchor]
    if (!ctrl.value) {
      ctrl.value = new window.BMapGL.ZoomControl({
        offset: size,
        anchor,
      })
      bmap.value.addControl(ctrl.value)
    }
    // unwatchBmap()
    // 动态导入updateScaleFactor, RippleOverlay
  },
  {
    immediate: true,
  },
)
</script>
